export default class PriceAdjustmentCondition {
    id = 0;
    triggerAmount = 0;
    triggerType;
    referenceId;
    init(other) {
        this.id = other.id;
        this.triggerAmount = other.triggerAmount;
        this.triggerType = other.triggerType;
        this.referenceId = other.referenceId;
    }
}
